(ns ui.view.card.counterparty-diligence-answers.view
  (:require
   [re-frame.core :as rf]
   [ui.view.sheets.event :as sheet-event]
   [ui.view.card.counterparty-diligence-answers.model :as model]
   [ui.view.card.counterparty-diligence-answers.event]
   [ui.view.card.shared-components.card-container :as card-container]
   [ui.view.counterparty-diligence.responder-form.view :as responder-form]
   [ui.view.card.sub :as common-sub]
   [common.localization :as loc]
   [reagent.core :as r]))

(defn form-view
  [{:keys [ctx] :as _props}]
  (r/create-class
   {:component-will-unmount (fn [_]
                              (rf/dispatch [::sheet-event/remove-group-sheets :counterparty-diligence-form]))
    :reagent-render
    (fn [{:keys [ctx]}]
      [responder-form/view
       {:root? true
        :lang-kw :en
        :state-path (model/form-state-full-path (:card-state-path ctx))}])}))

(defn content
  [{:keys [ctx] :as props}]
  (let [loading? @(rf/subscribe [::common-sub/loading? ctx])]
    (if loading?
      [:div
       {:class "h-56 flex flex-col items-center justify-center"}
       [:div (loc/tr :loading)]]
      [form-view props])))

(defn view
  [props]
  [card-container/view
   {:class "bg-transparent border-0 p-0"}
   [content props]])

